export const SENDING_REQUEST = 'PROJECTSLIST_SENDING_REQUEST';
export const GETALL_SUCCESS = 'PROJECTSLIST_GETALL_SUCCESS';
export const GETALL_FAILURE = 'PROJECTSLIST_GETALL_FAILURE';